<template>
  <div class="w-100 overflow-y-auto">
    <div class="container">
      <h2 class="text-center mb-4">
        {{ $t("novoParceiro") }}
      </h2>
      <ParceiroForm class="mb-4" media="" :video="false" :active="true" @salvar-parceiro="onSave" />
    </div>
  </div>
</template>
<script>
import ParceiroForm from './components/ParceiroForm';
import { addParceiro } from './parceiroService';
import { useToast } from 'vue-toastification';

export default {
  components: { ParceiroForm },
  methods: {
    async onSave(parceiro) {
      try {
        const response = await addParceiro(parceiro);
        if (response) {
          useToast().success('Parceiro cadastrado com sucesso.');
          this.$router.push('/admin/parceiros');
        } else {
          useToast().error(response);
        }
      } catch (error) {
        useToast().error('Erro de conexão');
      }
    },
  },
};
</script>
